var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      ref: "table",
      attrs: {
        data: _vm.innerData,
        height: _vm.height,
        "max-height": _vm.innerMaxHeight,
        stripe: _vm.stripe,
        border: _vm.border,
        size: _vm.size,
        fit: _vm.fit,
        "show-header": _vm.showHeader,
        "header-row-class-name": _vm.headerRowClassName,
        "header-row-style": _vm.headerRowStyle,
        "header-cell-class-name": _vm.headerCellClassName,
        "header-cell-style": _vm.headerCellStyle,
        "row-class-name": _vm.rowClassName,
        "row-style": _vm.rowStyle,
        "cell-class-name": _vm.cellClassName,
        "cell-style": _vm.cellStyle,
        "span-method": _vm.spanMethod,
        "highlight-current-row": _vm.highlightCurrentRow
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b14978d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b14978d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/ui/SasTable.vue
// module id = null
// module chunks = 